/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useContext } from 'react';
import './roleMaster.scss';
import DisabledEditIcon from '../../Assets/images/svg/dar_pencil_gray.svg';
import EditIcon from '../../Assets/images/svg/dar_pencil.svg';
import MagnifyingGlass from '../../Assets/images/svg/dar_magnifying.svg';
import ControlledSwitches from '../../Components/Switch/switch';
import DataGridComponent from '../../Components/DataGrid/dataGrid';
import { roleList } from '../../Api/request/role';
import UseAxios from '../../Api/http/http';
import EnableDisableRoleDialog from './enableDisableRoleDialog'; // Import the renamed dialog component
import {
  handleDialogSubmit,
  handleDialogClose,
} from './enableDisableRoleDialogUtils';
import ButtonComponent from '../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import {
  ADD_EDIT_RESPONSE_MESSAGES,
  ADD_EDIT_DIALOG,
  DOWNLOAD,
  ROLE_MASTER,
  ROLE_MASTER_FIELD,
  ROLE_MASTER_HEADERNAME,
} from '../../Constants/strings';
import RoleForm from './Roles/AddEditRole/addEditRole';
import { getRolesDataPdf, getRolesDataExcel } from '../../Api/request/reports';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDown from '../../Assets/images/svg/drop-down-arrow.svg';
import pdfIcon from '../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../Assets/images/svg/pdf_hover.svg';
import excelIcon from '../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../Assets/images/svg/excel_hover.svg';
import PuzzleLoader from '../../Assets/images/svg/loading puzzle.gif';

import { AuthContext } from '../../Contexts/AuthContext';
import SimpleSnackbar from '../../Components/Snackbar/snackbar';
import { MODULE_NAMES } from '../../Constants/modules';

const RoleMaster = () => {
  const [rows, setRows] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [roleId, setRoleId] = useState([]);
  const [roleValue, setRoleValue] = useState([]);
  const [roleDescription, setRoleDescription] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { userProfile } = useContext(AuthContext);
  const [severity, setSeverity] = useState('');
  const [snackBarCss, setSnackBarCss] = useState('');
  const [isPdfHovered, setIsPdfHovered] = useState(false);
  const [isExcelHovered, setIsExcelHovered] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_DELIVERY_ROLE] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const getRolesData = () => {
    // Fetch roles list using API
    setIsLoading(true);
    UseAxios(roleList())
      .then((response) => {
        const roles = response.data.roleDetails.map((role) => ({
          ...role,
          id: role.roleId,
        }));
        setRows(roles);
        setIsLoading(false);
      })
      .catch(() => {
        setRows([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRolesData();
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth < 1024);
  };

  const updateRoleList = () => {
    getRolesData();
    setSearchText('');
    clearSearchInput();
  };
  const clearSearchInput = () => {
    const searchInput = document.getElementById('role-search-input');
    if (searchInput) {
      searchInput.value = '';
    }
  };

  // add download reports
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };
  const handleDownloadPdf = async () => {
    try {
      await getRolesDataPdf();
    } catch (error) {
      setSnackBarCss('downloadrole-snackbar');
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleDownloadExcel = async () => {
    try {
      await getRolesDataExcel();
    } catch (error) {
      setSnackBarCss('downloadrole-snackbar');
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  // edit onClick function ,open edit modal
  const editHandleClickOpen = (roleIdVal, roleVal, roleDesc) => {
    setEditModalOpen(true);
    setIsEdit(true);
    setRoleId(roleIdVal);
    setRoleValue(roleVal);
    setRoleDescription(roleDesc);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const filteredRows
    = searchText.length >= 1
      ? rows.filter((row) => {
        return (
          row?.roleName?.toLowerCase().includes(searchText)
            || row?.description?.toLowerCase().includes(searchText)
        );
      })
      : rows;

  const handleSwitchChange = (data) => {
    // Actions to be performed after toggling enable/disable switch
    data.last_updated_by = userProfile.user_name;
    setSelectedRole(data); // Set the selected role data
    setIsDialogOpen(true);
    setIsEdit(true);
  };

  const enableDisableRoleSnackbar = (message, severityValue, cssClassName) => {
    setSnackBarCss(cssClassName);
    setOpenSnackbar(true);
    setSnackbarMessage(message);
    setSeverity(severityValue);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };

  const desktopColumns = [
    {
      field: ROLE_MASTER_FIELD.ROLE_NAME,
      headerName: ROLE_MASTER_HEADERNAME.ROLE_NAME,
      headerClassName: 'role-name-column',
      cellClassName: 'role-name-cell',
      flex: 0.25,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: ROLE_MASTER_FIELD.DESCRIPTION,
      headerName: ROLE_MASTER_HEADERNAME.DESCRIPTION,
      headerClassName: 'description-column',
      cellClassName: 'description-cell',
      flex: 0.59,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: ROLE_MASTER_FIELD.IS_ACTIVE,
      headerName: ROLE_MASTER_HEADERNAME.ENABLE_DISABLE,
      headerClassName: 'enable-disable-column',
      cellClassName: 'enable-disable-cell',
      flex: 0.2,
      renderCell: (params) => (
        <ControlledSwitches
          disabled={!hasAccess('delete')} // Disable switch based on permission
          checked={Boolean(params.value)}
          handleChange={() => {
            handleSwitchChange(params.row);
          }}
          inputProps={{ 'aria-label': 'enable/disable' }}
          switchCss="switchCss"
        />
      ),
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: ROLE_MASTER_FIELD.ROLE_CODE,
      headerName: ROLE_MASTER_HEADERNAME.ACTION,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      type: 'number',
      flex: 0.11,
      renderCell: (params) => (
        <button
          disabled={!hasAccess('update')} // Disable edit button based on permission
          id="roleMaster-edit-button"
          className="role-action-edit-icon"
          onClick={() =>
            editHandleClickOpen(
              params.row.roleId,
              params.row.roleName,
              params.row.description,
            )
          }
          aria-label="Edit"
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
          }}
        >
          <img
            src={!hasAccess('update') ? DisabledEditIcon : EditIcon}
            alt="Edit"
          />
        </button>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const mobileColumns = [
    {
      field: ROLE_MASTER_FIELD.ROLE_NAME,
      headerName: ROLE_MASTER_HEADERNAME.ROLE_NAME,
      headerClassName: 'role-name-column',
      cellClassName: 'role-name-cell',
      width: 186,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: ROLE_MASTER_FIELD.DESCRIPTION,
      headerName: ROLE_MASTER_HEADERNAME.DESCRIPTION,
      headerClassName: 'description-column',
      cellClassName: 'description-cell',
      width: 740,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'action',
      headerName: 'Action',
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      width: 120,
      renderCell: (params) => (
        <div className="mobile-action-icons">
          <ControlledSwitches
            disabled={!hasAccess('delete')} // Disable switch based on permission
            checked={Boolean(params.row.isActive)}
            handleChange={() => {
              handleSwitchChange(params.row);
            }}
            inputProps={{ 'aria-label': 'enable/disable' }}
            switchCss="switchCss"
          />
          <button
            id="roleMaster-edit-button"
            disabled={!hasAccess('update')} // Disable edit button based on permission
            className="role-action-edit-icon"
            onClick={() =>
              editHandleClickOpen(
                params.row.roleId,
                params.row.roleName,
                params.row.description,
              )
            }
            aria-label="Edit"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
            }}
          >
            <img
              src={!hasAccess('update') ? DisabledEditIcon : EditIcon}
              alt="Edit"
            />
          </button>
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const columns = window.innerWidth <= 768 ? mobileColumns : desktopColumns;
  const sortFilterColumns = [columns[0].field, columns[1].field];
  // Define the handleCloseSnackbar function
  return (
    <div className="role-master-outer-layer">
      <div className="role-master">
        <div className="role-master-title">{ROLE_MASTER}</div>
        <div className="role-search-and-buttons">
          <div className="role-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="role-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
          <div className="role-button">
            <div className="role-button-download">
              <ButtonComponent
                label={DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img alt="Arrow Down" src={ArrowDropDown} />}
                btnCss="download-role-btn"
              ></ButtonComponent>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={handleDownloadPdf}
                  className="download-dropdown"
                  onMouseEnter={() => setIsPdfHovered(true)}
                  onMouseLeave={() => setIsPdfHovered(false)}
                >
                  <img
                    src={isPdfHovered ? pdfhoverIcon : pdfIcon}
                    style={{ marginRight: 8 }}
                    alt="PDF Icon"
                  />{' '}
                  Download as PDF
                </MenuItem>
                <MenuItem
                  onClick={handleDownloadExcel}
                  className="download-dropdown"
                  onMouseEnter={() => setIsExcelHovered(true)}
                  onMouseLeave={() => setIsExcelHovered(false)}
                >
                  <img
                    src={isExcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="excel Icon"
                  />{' '}
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>

            <div className="role-button-add-role">
              <ButtonComponent
                disabled={!hasAccess('create')} // Disable add role button based on permission
                label={ADD_EDIT_DIALOG.ADD_ROLE}
                variant="contained"
                onClick={() => {
                  setAddModalOpen(true);
                  setIsEdit(false);
                }}
                startIcon={<AddIcon />}
                btnCss={
                  !hasAccess('create')
                    ? 'add-role-btn-disabled'
                    : 'add-role-btn'
                }
              ></ButtonComponent>
            </div>
            <RoleForm // add popup common component
              modalOpen={addModalOpen}
              handleClose={() => {
                setAddModalOpen(false);
              }}
              setRows={updateRoleList}
            />
            <RoleForm // edit popup common component
              modalOpen={editModalOpen}
              handleClose={() => {
                setEditModalOpen(false);
                setIsEdit(false);
              }}
              isEditMode={true}
              isEdit={isEdit}
              setRows={setRows}
              editId={roleId}
              editValue={roleValue}
              editDescription={roleDescription}
            />
          </div>
        </div>
        <div className="data-grid-container">
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px',
              }}
            >
              <img
                src={PuzzleLoader}
                alt="Loading..."
                className="loader-gif"
                style={{ width: '100px', height: 'auto' }}
              />
            </div>
          ) : filteredRows ? (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={isMobileView ? mobileColumns : desktopColumns}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              isFilteredRows={filteredRows}
              isEdit={isEdit}
            />
          ) : null}
        </div>
      </div>
      {isDialogOpen
        && selectedRole && ( // Enable/Disable role dialog
        <EnableDisableRoleDialog
          selectedRole={selectedRole}
          handleCloseAction={handleDialogClose}
          handleEnableDisableAction={handleDialogSubmit}
          setIsDialogOpen={setIsDialogOpen}
          setRows={setRows}
          handleSnackbar={enableDisableRoleSnackbar}
          setIsEdit={setIsEdit}
        />
      )}
      <SimpleSnackbar // SnackBar to handle response for enable/disable role & download report
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
        alertCss={snackBarCss}
      />
    </div>
  );
};

export default RoleMaster;
